export default __webpack_public_path__ + "static/s3-6db8e418c9996c1c21bba94ff699c7f8.png";